import { useTranslation } from "react-i18next"

function Button ({ title, type = "primary", styles, disabled = false, onClick = () => {} }) {
    const { t } = useTranslation()

    const defaultStyles = "py-2 px-6 rounded-full mt-2 transition"

    const theme = {
        primary: "bg-black text-white border-2 border-black hover:bg-transparent hover:text-black",
        secondary: "bg-white border-2 border-slate-200 text-slate-400 hover:bg-slate-200 hover:text-slate-400",
    }

    return <>
        <button 
            className={`${defaultStyles} ${theme[type]} ${styles}`}
            disabled={disabled}
            onClick={onClick}
        >
            {t(title)}
        </button>
    </>
}
export default Button